/**
 * Test Page Types
 */

export interface TestState {
  question: import('../types').Question | null;
  sectionInstruction: import('../types').SectionInstruction | null;
  selectedAnswer: string | null;
  loading: boolean;
  currentSection: string | null;
  version: string;
  showMemorization: boolean;
  showDistraction: boolean;
  showPreRule: boolean;
  dimensionTimeRemaining: number | null;
  dimensionTotalTime: number | null;
  canGoBack: boolean;
  distractionTime: number;
  distractionMoves: number;
}

export interface TimeTracking {
  instructionStartTime: number | null;
  preRuleStartTime: number | null;
  questionStartTime: number | null;
}

export type TestPhase = 
  | 'instruction' 
  | 'pre-rule' 
  | 'memorization' 
  | 'distraction' 
  | 'question' 
  | 'loading';

/**
 * Get puzzle size from distraction type
 */
export const getPuzzleSize = (type: string): number => {
  if (type === 'puzzle_4') return 4;
  if (type === 'puzzle_6') return 6;
  return 8;
};
